// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=pro` then `environment.pro.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  api: 'https://informo.madrid.es/api',
  imageHost: 'https://informo.madrid.es',
  city: 'informo',
  title: 'Informo',
  citylogo: '/assets/logos/ayto-madrid.svg',
  citylogoMobile: '/assets/logos/ayto-madrid-redux.svg',
  center: [-3.664455413818359, 40.43963107298772],
  zoom: 11,
  featuresInitialZoom: 7,
  unitLength: 'km',
  theme: 'informo',
  applicationLogo: '/assets/logos/informo.svg',
  loginApplicationLogo: '/assets/logos/informo-negro.svg',
  platesAPI: 'https://europe-west1-carto-ps-madrid-informo-pro.cloudfunctions.net/plate-type-fn',
  showGeographica: false,
  overrideWazeAlerts: true,
  options: {
    cameras: 'images',
    sources: ['informo'],
    cartoAccount: 'kapsch-admin'
  },
  carto: {
    connection: 'carto-ps-webapp-pro',
    tablePrefix: 'carto-ps-madrid-informo-pro.pro',
    apiBaseUrl: 'https://gcp-europe-west1.api.carto.com',
    sqlEndpoint: '/v3/sql/carto-ps-webapp-pro/query',
    accessToken: 'eyJhbGciOiJIUzI1NiJ9.eyJhIjoiYWNfaXc4cGQ5MDciLCJqdGkiOiJlZmQ4NDcxYyJ9.Nz3uN-BcM5gC2lHZdoqqUQcTaed8Em0sfUwaLg7NJss'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts